import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/** Contractul lui GET /api/v2/me. */
export interface Me {
  id: number
  email: string
  company: number
  office: number
  serviceProvider: number
  access: number
  isAdmin: boolean
  can: Record<string, boolean>
  version: string
  /** Semnul sesiunii de login (`auth_time` din jeton); 0 pe un jeton vechi. */
  authTime: number
}

export const meQuery = queryOptions({
  queryKey: ['me'],
  queryFn: () => apiGet<Me>('/me'),
  staleTime: 5 * 60_000,
})
